import {
  Button,
  CloseButton,
  Dialog,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@compass/core";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { DataModelInformation } from "components";
import { DataModelEnum, StudentProgramListDto } from "generated/openApi";

export const ProgramHistoryDialog = (props: { studentId: number; onClose: () => void }) => {
  const [programs, setPrograms] = useState<StudentProgramListDto[]>([]);
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [reload, setReload] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setHasError(false);
    ApiService.students.getProgramHistory(props.studentId)
      .then((response) => {
        if (!cancelled) setPrograms(response);
      })
      .catch(() => {
        if (!cancelled) setHasError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [props.studentId, reload]);

  return (
    <Dialog
      open
      maxWidth="md"
      onClose={props.onClose}
      header={
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">Student Program History</Typography>
          <CloseButton theme="Dark" onClick={props.onClose} />
        </Stack>
      }
      content={
        loading ? <Typography>Loading program history…</Typography> : hasError ? (
          <Stack spacing="sm">
            <Typography>Unable to load program history.</Typography>
            <Button onClick={() => setReload((value) => value + 1)}>Retry</Button>
          </Stack>
        ) : programs.length === 0 ? <Typography>No program history recorded.</Typography> : (
          <TableContainer>
            <Table aria-label="Student program history">
              <TableHead>
                <TableRow>
                  <TableCell>School Year</TableCell>
                  <TableCell>Program</TableCell>
                  <TableCell align="right">Record Information</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {programs.map((program) => (
                  <TableRow key={program.id}>
                    <TableCell>{program.year != null ? `${program.year}/${program.year + 1}` : ""}</TableCell>
                    <TableCell>{program.program}</TableCell>
                    <TableCell align="right">
                      <DataModelInformation color="primary" dataModelType={DataModelEnum.StudentProgram} dataModelId={program.id} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )
      }
    />
  );
};
